import React from 'react';

interface PaginationProps {
  totalItems: number;
  itemsPerPage: number;
  currentPage: number;
  onPageChange: (page: number) => void;
  onItemsPerPageChange: (limit: number) => void;
}

export const Pagination: React.FC<PaginationProps> = ({
  totalItems,
  itemsPerPage,
  currentPage,
  onPageChange,
  onItemsPerPageChange
}) => {
  const totalPages = Math.ceil(totalItems / itemsPerPage) || 1;

  // Let's show a sliding window of pages to avoid too many buttons
  const maxPagesToShow = 5;
  let startPage = Math.max(1, currentPage - Math.floor(maxPagesToShow / 2));
  let endPage = startPage + maxPagesToShow - 1;

  if (endPage > totalPages) {
    endPage = totalPages;
    startPage = Math.max(1, endPage - maxPagesToShow + 1);
  }

  const pages = [];
  for (let i = startPage; i <= endPage; i++) {
    pages.push(i);
  }

  if (totalItems === 0) return null;

  return (
    <div className="pagination-wrapper">
      <div className="pagination-controls">
        <button 
          className="btn ghost sm" 
          disabled={currentPage === 1}
          onClick={() => onPageChange(currentPage - 1)}
        >
          &laquo; Wstecz
        </button>

        <div className="pagination-pages">
          {startPage > 1 && <span style={{padding: '0 4px', color: 'var(--v900)'}}>...</span>}
          {pages.map(p => (
            <button
              key={p}
              className={`btn sm ${p === currentPage ? 'active' : 'ghost'}`}
              onClick={() => onPageChange(p)}
            >
              {p}
            </button>
          ))}
          {endPage < totalPages && <span style={{padding: '0 4px', color: 'var(--v900)'}}>...</span>}
        </div>

        <button 
          className="btn ghost sm" 
          disabled={currentPage === totalPages}
          onClick={() => onPageChange(currentPage + 1)}
        >
          Dalej &raquo;
        </button>
      </div>

      <div className="pagination-limit">
        <span>Pokaż:</span>
        <select 
          value={itemsPerPage} 
          onChange={(e) => {
            onItemsPerPageChange(Number(e.target.value));
            onPageChange(1);
          }}
        >
          <option value={10}>10</option>
          <option value={20}>20</option>
          <option value={50}>50</option>
          <option value={100}>100</option>
        </select>
      </div>
    </div>
  );
};
